import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

const useGetMasterTypes = ({ page = 1, pageSize = 20 } = {}) => {
    const { data, isLoading, isFetching } = useQuery({
        queryKey: ['master-type', , page, pageSize],
        queryFn: () =>
            api.masterType.list({
                page,
                take: pageSize,
                order: 'ASC',
            }),
        staleTime: 10000,
    })

    return {
        data,
        isLoading,
        isFetching,
    }
}

export default useGetMasterTypes
